import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import Caption from 'LuxKit/Typography/Caption'
import Divider from 'LuxKit/Divider'
import type { CruiseOnlyOfferView } from 'hooks/Cruise/useCruiseOfferView'
import { isDisplayablePrice } from 'lib/offer/pricingVisibility'
import productLabels from 'i18n/productLabels'
import CruiseOverviewPriceDetails from '../CruiseOverviewPrice/CruiseOverviewPriceDetails'

interface Props {
  view: CruiseOnlyOfferView
  hasValidDepartures: boolean
}

function CruiseStickyPrices({ view, hasValidDepartures }: Props) {
  const intl = useIntl()
  const bundlePrice = view.lowestBundlePrice?.promotionalPrice?.total ?? view.lowestBundlePrice?.primaryPrice.total
  const hasBundlePrice = isDisplayablePrice(bundlePrice)
  const bundleTitle = intl.formatMessage({
    id: 'F9Fbw7vK0bAkoyrV7y0y',
    defaultMessage: 'Cruise + Hotel',
    description: 'Label for the combined cruise and hotel price in the sticky offer header or mobile footer',
  })

  return <Group direction="horizontal" gap={16}>
    <Group direction="vertical" gap={4}>
      {hasBundlePrice && <Caption variant="medium" weight="bold">{intl.formatMessage(productLabels.cruise)}</Caption>}
      <CruiseOverviewPriceDetails
        view={view}
        hasValidDepartureDates={hasValidDepartures}
        priceType="standard"
        size="small"
      />
    </Group>
    {hasBundlePrice && <>
      <Divider kind="primary" direction="vertical" />
      <Group direction="vertical" gap={4}>
        <Caption variant="medium" weight="bold">{bundleTitle}</Caption>
        <CruiseOverviewPriceDetails
          view={view}
          hasValidDepartureDates={hasValidDepartures}
          priceType="bundle"
          size="small"
        />
      </Group>
    </>}
  </Group>
}

export default CruiseStickyPrices
